import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcaaaed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = {
  key: 0,
  class: "news"
}
const _hoisted_4 = { class: "news-line-lt" }
const _hoisted_5 = {
  key: 0,
  class: "news-line-status color1"
}
const _hoisted_6 = {
  key: 1,
  class: "news-line-status color2"
}
const _hoisted_7 = {
  key: 0,
  style: {"font-size":"14px","font-weight":"bold","color":"#3399ff"}
}
const _hoisted_8 = {
  key: 1,
  style: {"font-size":"14px","font-weight":"bold","color":"#3399ff"}
}
const _hoisted_9 = { class: "news-line-pushtime" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "news-line-title" }
const _hoisted_12 = {
  key: 0,
  class: "news-line-content"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }

import { defineComponent } from 'vue';
import store from '@/store/index';
import { useStore } from '@/store/index';
import { ref, reactive } from 'vue';
import tool from '@/utils/tool';
import router from '@/router/index';
import { ElButton, ElMessage, ElMessageBox } from 'element-plus';
import type { ElForm, Action } from 'element-plus';

interface NoticeVo {
  id: string;
  title: string;
  content: string;
  pushTime: string;
  creatorName: string;
  receiverName: string;
  isRead: string;
  noticeBoxType: string;
  isShow: string;
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ustore = useStore();
const loading = ref(true);

const bindData = reactive({
  noticeBoxTypeOptions: [
    {
      value: '1',
      label: '收信箱',
    },
    {
      value: '2',
      label: '发信箱',
    },
  ],
  readStatusOptions: [
    {
      value: '',
      label: '阅读状态',
    },
    {
      value: 'Y',
      label: '已读',
    },
    {
      value: 'N',
      label: '未读',
    },
  ],
  searchTimeOptions: [
    {
      value: '',
      label: '不限时间',
    },
    {
      value: '1',
      label: '近7天',
    },
    {
      value: '2',
      label: '近30天',
    },
    {
      value: '3',
      label: '近半年',
    },
  ],
  noticePageParams: {
    noticeBoxType: '1',
    curPage: 1,
    pageSize: 10,
    filtrate: {
      isRead: '',
      searchTime: '',
      keyword: '',
    },
  },
  noticePageResult: {
    status: 2000,
    msg: '成功',
    result: [],
    totalCount: 0,
  },
});

const handleSizeChangeEvent = (value: any) => {
  bindData.noticePageParams.pageSize = value;
  bindData.noticePageParams.curPage = 1;
  searchEvent();
};

const handleCurrentChangeEvent = (value: any) => {
  bindData.noticePageParams.curPage = value;
  searchEvent();
};

const searchEvent = () => {
  store
    .dispatch(
      'noticesModule/pageNoticeList',
      bindData.noticePageParams
    )
    .then(
      (data) => {
        //成功
        for (var index in data.result) {
          const obj = data.result[index];
          obj.noticeBoxType = Number(bindData.noticePageParams.noticeBoxType);
          obj.isShow = 'N';
        }
        bindData.noticePageResult = data;
        loading.value = false;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

searchEvent();

  const showNoticeContent = (itemid: string) => {
    for (var index in bindData.noticePageResult.result) {
      const notice = bindData.noticePageResult.result[index] as NoticeVo;
      if (notice.id == itemid) {
        notice.isShow = notice.isShow == "Y" ? "N" : "Y";
        notice.isRead = 'Y';
        if(notice.content==null || notice.content.length<=0) {
          notice.content = "没有内容！";
        }
      }
    }
    if (Number(bindData.noticePageParams.noticeBoxType) == 1) {
      //收信箱
      updateIsRead(itemid);
    }
  };

const updateIsReadEvent = (noticeId: string) => {
  ElMessageBox.confirm(`您确定要对当前消息标记为已读吗?`)
    .then(() => {
      const params = {
        id: noticeId,
      };
      store.dispatch('noticesModule/readNotice', params).then(
        (data) => {
          //成功
          ElMessage.success('操作成功.');
          searchEvent();
        },
        (error) => {
          ElMessageBox.alert(error.msg, '系统消息', {
            confirmButtonText: '关闭',
            callback: (action: Action) => {},
          });
        }
      );
    })
    .catch(() => {
      // catch error
    });
};

const updateIsRead = (noticeId: string) => {
  const params = {
    id: noticeId,
  };
  store.dispatch('noticesModule/readNotice', params).then(
    (data) => {
      //成功
    },
    (error) => {
      ElMessageBox.alert(error.msg, '系统消息', {
        confirmButtonText: '关闭',
        callback: (action: Action) => {},
      });
    }
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "notice-search" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { class: "notice-search-lt" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { style: {"margin-right":"18px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).noticePageParams.noticeBoxType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).noticePageParams.noticeBoxType) = $event)),
                  placeholder: "信箱类型",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).noticeBoxTypeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"margin-right":"18px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).noticePageParams.filtrate.isRead,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).noticePageParams.filtrate.isRead) = $event)),
                  placeholder: "阅读状态",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).readStatusOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _unref(bindData).noticePageParams.filtrate.searchTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).noticePageParams.filtrate.searchTime) = $event)),
                  placeholder: "不限时间",
                  size: "large",
                  onChange: searchEvent
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).searchTimeOptions, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "notice-search-lt-text" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "",
                  size: "large",
                  modelValue: _unref(bindData).noticePageParams.filtrate.keyword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).noticePageParams.filtrate.keyword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "notice-search-lt-btn" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ElButton), {
                  type: "primary",
                  size: "large",
                  onClick: searchEvent
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_unref(bindData).noticePageResult.totalCount > 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).noticePageResult.result, (item) => {
                return (_openBlock(), _createBlock(_component_el_col, { key: item }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_card, { class: "news-line" }, {
                      default: _withCtx(() => [
                        (item.noticeBoxType == 1)
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                (item.isRead == 'Y')
                                  ? (_openBlock(), _createBlock(_component_Message, { key: 0 }))
                                  : (_openBlock(), _createBlock(_component_Message, {
                                      key: 1,
                                      style: {"color":"blue"},
                                      onClick: ($event: any) => (updateIsReadEvent(item.id))
                                    }, null, 8, ["onClick"]))
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                          (item.noticeBoxType == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 发件人 "))
                            : _createCommentVNode("", true),
                          (item.noticeBoxType == 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " 收件人 "))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          (item.noticeBoxType == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.creatorName), 1))
                            : _createCommentVNode("", true),
                          (item.noticeBoxType == 2)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.receiverName), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_9, _toDisplayString(item.pushTime), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "news-line-rt",
                          onClick: ($event: any) => (showNoticeContent(item.id))
                        }, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                          (item.isShow=='Y')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item.content), 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_10),
                        _createElementVNode("div", {
                          style: {"float":"right"},
                          onClick: ($event: any) => (showNoticeContent(item.id))
                        }, [
                          (item.isShow=='N')
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 0,
                                src: require('@/assets/u3941-2.png'),
                                style: {"margin-right":"0px","vertical-align":"middle","width":"20px","height":"10px","padding-right":"5px"},
                                fit: "fill"
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          (item.isShow=='Y')
                            ? (_openBlock(), _createBlock(_component_el_image, {
                                key: 1,
                                src: require('@/assets/u3941.png'),
                                style: {"margin-right":"0px","vertical-align":"middle","width":"20px","height":"10px","padding-right":"5px"},
                                fit: "fill"
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_13)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ])), [
          [_directive_loading, loading.value]
        ])
      : (_openBlock(), _createElementBlock("div", _hoisted_14, "暂无数据")),
    _createVNode(_component_el_container, { class: "notice-page_toolbar" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_pagination, {
          currentPage: _unref(bindData).noticePageParams.curPage,
          "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).noticePageParams.curPage) = $event)),
          "page-size": _unref(bindData).noticePageParams.pageSize,
          "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).noticePageParams.pageSize) = $event)),
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _unref(bindData).noticePageResult.totalCount,
          "onUpdate:total": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).noticePageResult.totalCount) = $event)),
          onSizeChange: handleSizeChangeEvent,
          onCurrentChange: handleCurrentChangeEvent
        }, null, 8, ["currentPage", "page-size", "total"])
      ]),
      _: 1
    })
  ]))
}
}

})